import { gql } from "graphql-request";

// Query to check if metal percentage is required for a product
export const CHECK_METAL_PERCENTAGE_REQUIRED = gql`
  query CheckMetalPercentageRequired($input: MetalPercentageCheckInput!) {
    checkMetalPercentageRequired(input: $input) {
      isMetalPercentageRequired
      applicableMetalRules {
        _id
        name
        rules {
          data {
            _id
            rate
            authority
            isMetal
            valueBasis
          }
        }
      }
    }
  }
`;

// Query to calculate duty with metal percentage
export const CALCULATE_DUTY_WITH_METAL = gql`
  query CalculateDutyWithMetal($input: DutyCalculationInput!) {
    calculateDutyWithMetal(input: $input) {
      baseRate
      metalAdjustedRate
      totalRate
      breakdown {
        columnName
        originalRate
        metalPercentage
        adjustedRate
        applied
        reason
      }
    }
  }
`; 